/*
 * The Invoices list in the URL (?view=), parsed on mount and written back with history.replace.
 * Pure; Confirmed, the default, is left out.
 */
import { STATUS_ALL, STATUS_CONFIRMED, STATUS_SUPERSEDED } from './requests';
import { VIEW_AWAITING } from './adapters';
import { merge_query } from '../shared/url_query';

const VIEW_KEYS = {
  confirmed: STATUS_CONFIRMED,
  replaced: STATUS_SUPERSEDED,
  all: STATUS_ALL,
  awaiting: VIEW_AWAITING
};

export const invoices_view_from_search = (search) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  return VIEW_KEYS[(qs.get('view') || '').trim()] || STATUS_CONFIRMED;
};

// Merged into the current search so ?month= and every other param survive.
export const invoices_search = (search, view) => {
  const key = Object.keys(VIEW_KEYS).find((k) => VIEW_KEYS[k] === view);
  return merge_query(search, ['view'], { view: key && view !== STATUS_CONFIRMED ? key : '' });
};
